<div #list [hidden]="hidden()" class="dropdown-menu scrollable-menu" [class.drop-up]="dropUp()">
  <mat-list>
    @for (item of items(); track item; let i = $index) {
      <button #matListItemRef mat-list-item [activated]="activeIndex()===i"
        [class.active]="activeIndex()===i" [class.mention-active]="!styleOff() && activeIndex()===i"
      class="dropdown-item" (mousedown)="activeIndex.set(i);itemClick.emit();$event.preventDefault()">{{item[labelKey()]}}</button>
    }
  </mat-list>
</div>
